module.exports = __webpack_public_path__ + "img/horizontal_3_7_3.3999a45b.png";